export default "__VITE_ASSET__BLqdqfo0__"